<template>
  <path
    id="filter"
    d="M23.9355258,1.41042544 C23.8154081,1.15703947 23.5589694,0.995416667 23.2773041,0.995416667 L0.722734071,0.995416667 C0.441068766,0.995416667 0.184727141,1.15703947 0.0645124273,1.41042544 C-0.0556052606,1.6638114 -0.0179593293,1.96332018 0.161246947,2.17946052 L8.83155124,12.6375657 L8.83155124,22.2808991 C8.83155124,22.5312938 8.96166256,22.7638378 9.17550698,22.8958377 C9.29271389,22.9681096 9.42573599,23.0045833 9.55924321,23.0045833 C9.66956132,23.0045833 9.78026752,22.9795921 9.88233845,22.9293202 L14.7537995,20.528136 C15.0013118,20.406171 15.1579111,20.1553904 15.1582993,19.8806798 L15.1678078,12.6378553 L23.8385972,2.17936403 C24.0179005,1.96332018 24.0556435,1.66371491 23.9355258,1.41042544 Z M13.8791138,11.9172587 C13.7719006,12.046557 13.713103,12.2089517 13.712909,12.3766535 L13.7035945,19.4304517 L10.2870322,21.1145131 L10.2870322,12.3776184 C10.2870322,12.2096272 10.2283317,12.0468465 10.1208273,11.9172587 L2.26582915,2.4426886 L21.734112,2.4426886 L13.8791138,11.9172587 Z"
    :fill="iconColor"
  />
</template>

<script>
export default {
    name: 'FiltersIcon',
    props: {
        iconColor: {
            type: String,
            default: 'currentColor'
        }
    }
};
</script>

<style scoped></style>
